import { ref } from 'vue';

export class CsvFormField {
	public keys = ref<string[]>([]);
	public unmatchedInput: string[] = [];

	public clear(): void {
		this.keys.value = [];
		this.unmatchedInput = [];
	}
}
